import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';

export const MenuButton = ({ title, url }) => {
  return (
    <Button
      variant="text"
      size="sm"
      className="sm-header__nav-cta--alt sm-header__text"
      href={url}
      key={title}
    >
      {title}
    </Button>
  );
};

MenuButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  title: PropTypes.any.isRequired,
  url: PropTypes.string.isRequired,
};

export default MenuButton;
